import React from "react";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import appStore from "app/store";
import App from "views/App";
import "bootstrap/dist/css/bootstrap.min.css";
import "./i18n";

const Client = () => (
    <Provider store={appStore}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>
);

export default Client;
